var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FieldWrapper',{attrs:{"label":_vm.label,"state":_vm.state,"configs":_vm.configs}},[_c('div',{staticClass:"column full-width"},[_c('div',{staticClass:"col"},[_c('q-input',{ref:"inputRef",attrs:{"value":_vm.formattedValue,"dense":"","outlined":"","placeholder":_vm.placeholder,"bg-color":"white","readonly":_vm.disabled}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }